// File: Institutional_trend_mapping.js

const sanitize = (value) => {
    return String(value)
      .replace(/[^\w\s]/g, '')     // remove punctuation but keep spaces
      .replace(/\s+/g, ' ')        // collapse multiple spaces
      .trim()
      .toLowerCase();
  };
  
  const normalizeCountry = (val) => {
    if (!val) return 'Global';
    const map = {
      'us': 'USA',
      'united states': 'USA',
      'n/a': 'Global',
      'global': 'Global',
      'eu': 'Europe',
      'european union': 'Europe',
    };
    const key = sanitize(val);
    return map[key] || val;
  };
  
  const formatKeyComponent = (str) =>
    sanitize(str).replace(/ /g, '_'); // keep underscores to match backend format
  
  const Institutional_trend_mapping = (country, sector, tooltip, vectorInstitutionalTrend) => {
    const rawCountry = Array.isArray(country) ? country[0] : country;
    const rawSector = Array.isArray(sector) ? sector[0] : sector;
  
    if (!rawSector || String(rawSector).includes('N/A')) {
      console.log('Skipping due to missing or invalid sector:', rawSector);
      return { color: null, tooltip };
    }
  
    const rawCountryClean = (!rawCountry || String(rawCountry).includes('N/A')) ? 'Global' : rawCountry;
  
    // console.log('vectorInstitutionalTrend:', vectorInstitutionalTrend);
    // console.log('Raw country:', rawCountry);
    // console.log('Raw sector:', rawSector);
  
    if (
      !vectorInstitutionalTrend ||
      !Array.isArray(vectorInstitutionalTrend.columns) ||
      !Array.isArray(vectorInstitutionalTrend.rows)
    ) {
      return { color: null, tooltip };
    }
  
    const normalizedCountry = normalizeCountry(rawCountryClean);
    const countryKey = formatKeyComponent(normalizedCountry);
    const sectorKey = formatKeyComponent(rawSector);
    const targetKey = `Institutional_trend_${countryKey}_${sectorKey}`;
  
    // console.log('Looking for:', targetKey);
  
    let colIndex = -1;
    const matchKey = vectorInstitutionalTrend.columns.find((col, idx) => {
      if (col.toLowerCase() === targetKey.toLowerCase()) {
        colIndex = idx;
        return true;
      }
      return false;
    });
  
    if (!matchKey || colIndex === -1) {
      console.log('No match found');
      return { color: null, tooltip };
    }
  
    const trendValue = vectorInstitutionalTrend.rows[0][colIndex];
    if (!trendValue) return { color: null, tooltip };
  
    let color = null;
    if (trendValue.toLowerCase().includes('buying')) color = 'lightgreen';
    else if (trendValue.toLowerCase().includes('selling')) color = 'lightcoral';
  
    const readableCountry = normalizedCountry;
    const enhancedTooltip = `${tooltip || ''} (Institutional trend ${readableCountry} ${rawSector}: ${trendValue})`;
  
    // console.log('→ Match column:', matchKey);
    // console.log('→ Trend:', trendValue);
    // console.log('→ Color:', color);
    // console.log('→ Tooltip:', enhancedTooltip);
  
    return {
      color,
      tooltip: enhancedTooltip,
    };
  };
  
  export default Institutional_trend_mapping;
  